export const SERVICE_STATUS_ACCEPTED = "accepted";
export const SERVICE_STATUS_PROCESSED = "processed";
export const SERVICE_STATUS_REJECTED = "rejected";
export const SERVICE_STATUS_FINISHED = "finished";

export const API_URL = process.env.REACT_APP_API_URL;

export const TYPE_1 = "Pendaftaran Penduduk";
export const TYPE_2 = "Pencatatan sipil";
